import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ConlicitasegState } from 'store/modules/conlicitaseg_store/types';
import { createClientPolicyholder } from 'store/modules/conlicitaseg_store/actions';
import { formatCNPJ, sanitizeCnpj } from 'services/conlicitaseg';
import { ClientPolicyholdersModalStyles } from './styles';

interface ClientPolicyholdersModalProps {
  show: boolean;
  onHide: () => void;
  cnpj: string;
  companyName: string;
  isLinked: boolean;
}

const ClientPolicyholdersModal = ({
  show,
  onHide,
  cnpj,
  companyName,
  isLinked,
}: ClientPolicyholdersModalProps) => {
  const dispatch = useDispatch();
  const { client_policyholders, request } = useSelector<ApplicationState, ConlicitasegState>(
    (state) => state.session.conlicitaseg,
  );

  const [submitted, setSubmitted] = useState(false);

  const storedCnpjs = client_policyholders || [];
  const cleanCnpj = sanitizeCnpj(cnpj);
  const { loading, error } = request.create_client_policyholder || {};

  const policyholders =
    isLinked && cleanCnpj !== '' && !storedCnpjs.includes(cleanCnpj)
      ? [cleanCnpj, ...storedCnpjs]
      : storedCnpjs;

  useEffect(() => {
    if (show) setSubmitted(false);
  }, [show]);

  const handleAdd = () => {
    if (loading || cleanCnpj.length !== 14) return;
    setSubmitted(true);
    dispatch(createClientPolicyholder(cleanCnpj));
  };

  return (
    <>
      <ClientPolicyholdersModalStyles />
      <Modal show={show} onHide={onHide} scrollable dialogClassName="client-policyholders-modal">
        <Modal.Header>
          <Modal.Title>CNPJs</Modal.Title>
          <button type="button" className="close-button" aria-label="Fechar" onClick={onHide}>
            <i className="material-icons">close</i>
          </button>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          {request.get_client_policyholders?.loading ? (
            <div className="text-center py-3">
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
            </div>
          ) : (
            <>
              {policyholders.length > 0 ? (
                <ul className="list-unstyled mb-0">
                  {policyholders.map((policyholderCnpj) => (
                    <li key={policyholderCnpj} className="policyholder-item">
                      {formatCNPJ(policyholderCnpj)}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="mb-0">Você ainda não tem CNPJs vinculados à sua empresa.</p>
              )}

              {!isLinked && cleanCnpj.length === 14 && (
                <div className="mt-4">
                  <p className="mb-3">
                    Deseja vincular o CNPJ <strong>{formatCNPJ(cleanCnpj)}</strong>
                    {companyName ? ` - ${companyName}` : ''} para futuras cotações e emissões de
                    seguro garantia?
                  </p>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleAdd}
                    disabled={loading}
                  >
                    {loading ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      'Vincular CNPJ'
                    )}
                  </button>
                </div>
              )}

              {submitted && storedCnpjs.includes(cleanCnpj) && (
                <small className="form-text text-success mt-3">CNPJ vinculado com sucesso.</small>
              )}

              {submitted && error && (
                <small className="form-text text-danger mt-3">
                  Não foi possível vincular o CNPJ. Tente novamente.
                </small>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ClientPolicyholdersModal;
